import styled, { css } from "styled-components";
import type { FooterVariantsType } from "./Footer";

// STYLES
const pageFooter = css`
    padding: var(--spacing-7) 0 var(--spacing-8);
    border-top: 1px solid var(--color-platinum-light);
`;

// COMPONENTS
export const FooterVariants = {
    "page-footer": pageFooter,
};

const FooterVariant = styled.div<{ variant: FooterVariantsType }>`
    ${(props) =>
        props.variant &&
        css`
            ${FooterVariants[props.variant]}
        `};
`;

export default FooterVariant;
